import { createSlice } from "@reduxjs/toolkit";

const modalModel = {
  id: "",
  title: "",
  texts: [],
  status: "",
  position: "middle",
  autoClose: false,
  blocking: false,
  buttons: [],
  isModalOpen: false,
};

export const modalSlice = createSlice({
  name: "modal",
  initialState: modalModel,
  reducers: {
    setData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },

    openModal: (state) => {
      return { ...state, isModalOpen: true };
    },
    closeModal: (state) => {
      return {
        id: "",
        isModalOpen: false,
        buttons: [],
        blocking: false,
        autoClose: false,
        position: "middle",
        title: "",
        texts: [],
        status: "",
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setData, openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
